import BaseModel from '../../../../BaseModel';
import makeQuery from '../../../../../api/makeQuery';
import mapValues from 'lodash/mapValues';
import {makeObservable} from 'mobx';
import User from '../../../../../singletons/User';


class Log extends BaseModel {
  static INITIAL_FIELDS = {
    id: '',
    userId: '',
    from: '',
    body: ''
  };

  get canUserRemove() {
    return this.userId && User.user?.id === this.userId;
  }

  constructor(logs, initialValues) {
    super(initialValues);

    makeObservable(this, {
      ...mapValues(this.constructor.INITIAL_FIELDS, () => true),
      destroy: false,
      map: false,
      remove: false,
      canUserRemove: true
    });

    this.logs = logs;
  }


  async updateEntry({ body }) {
    const res = await makeQuery('@putEntry', {
      postId: this.logs.post.id,
      entryId: this.id,
      body,
    });
    this.logs.post?.merge?.(res);
    return true;
  }

  async remove() {
    if (!this.canUserRemove) {
      throw new Error('It is forbidden to remove this log');
    } else {
      await makeQuery('@deleteEntry', {
        postId: this.logs.post.id,
        entryId: this.id,
      });
      /* returns null, so unsafe to merge here */
    }
  }

  destroy() {}
}

export default Log;
